import { useState, useEffect } from "react";
import { UserGroupIcon, CursorArrowRippleIcon, ArrowLeftStartOnRectangleIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import SkeletonCard from "../../Skeleton/SkeletonCard";
import cdpService from "../../../apiService/cdp.service";

const iconMap = {
    total_registered_users: UserGroupIcon,
    current_month_signups: CursorArrowRippleIcon,
    todays_signups: ArrowLeftStartOnRectangleIcon,
};

const colorMap = {
    total_registered_users: { bg: "bg-red-100", iconColor: "text-red-500" },
    current_month_signups: { bg: "bg-green-100", iconColor: "text-green-500" },
    todays_signups: { bg: "bg-purple-100", iconColor: "text-purple-500" },
};

const StatsCard = () => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        cdpService.getOverallDemographicCount()
            .then((response) => response.data)
            .then((data) => {
                if (data.success && data.data) {
                    setStats([
                        {
                            id: 1,
                            key: "total_registered_users",
                            name: "Total Registered Users",
                            stat: data.data.signupCounts.totalSignups || 0,
                        },
                        {
                            id: 2,
                            key: "current_month_signups",
                            name: "Current Month Sign-ups",
                            stat: data.data.signupCounts.totalMonthlySignups || 0,
                        },
                        {
                            id: 3,
                            key: "todays_signups",
                            name: "Today's Sign-Ups",
                            stat: data.data.signupCounts.totalTodaySignups || 0,
                        },
                    ]);
                }
                setLoading(false);
            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    }, []);

    if (loading) return <SkeletonCard length={3}/>;
    if (error) return <p>Error loading stats.</p>;

    return (
        <>
                {stats.map((item) => {
                    const Icon = iconMap[item.key] || UserGroupIcon;
                    const { bg, iconColor } = colorMap[item.key] || { bg: "bg-gray-100", iconColor: "text-gray-500" };

                    return (
                        <div key={item.id} className="relative px-6 py-6">
                            <div className="flex items-center">
                                <div className="mr-4">
                                    <div className={`rounded-full p-5 ${bg}`}>
                                        <Icon aria-hidden="true" className={`w-8 h-8 ${iconColor}`} />
                                    </div>
                                </div>
                                <dd>
                                    <p className="truncate text-sm font-medium text-gray-500 flex">
                                        {item.name} <InformationCircleIcon aria-hidden="true" className="size-5 ms-1" />
                                    </p>
                                    <p className="text-3xl font-bold text-gray-900">{item.stat.toLocaleString()}</p>
                                </dd>
                            </div>
                        </div>
                    );
                })}
            
        </>
    );
};

export default StatsCard;
